export const clickTypeEvents = ["mousedown", "keypress", "touchmove", "touchstart"];

/**
 * Prevent use of contextmenu (right-click) if not in dev env
 * If an element has `data-force-reload` attribute long press is permitted
 */
export const disableContextClick = e => {
    if (e.target.dataset['forceReload']) return;
    
    process.env.NODE_ENV !== 'development' && e.preventDefault();
}

/**
 * 
 * @param {*} menuHash Needed to prevent redirecting to the root
 * @param {*} disable Makes it possible to disable this functionality if needed in certain scenarios
 */
export const forceHardReload = (menuHash, disable) => {
    if (disable) return;

    const currentLocation = new URL(location);
    const isKiosk = currentLocation.searchParams.get('mode')
    const newLocation = `${ currentLocation.origin }/${menuHash}/${isKiosk === 'kiosk' && 'start/kiosk/'}` + currentLocation.search;

    location.href = newLocation;
}